// extracted by mini-css-extract-plugin
export var closeButton = "_m3-1";
export var closeX = "_m3-3";
export var container = "_m3-0";
export var image = "_m3-2";